// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  uploadImageHostname: "node.deso.org",
  verificationEndpointHostname: "https://node.deso.org",
  uploadVideoHostname: "media.deso.org",
  identityURL: "https://identity.deso.org",
  apiInternalHostname: "https://node.deso.org",
  webPushServerVapidPublicKey:
    "BBt2v52sa0J-1D6w25XGk-eXqSOWdnfddV256XXI1B-UZlfX-HSIDzv4TkXbTLhHHNjDc45yZ8jsZWsXWg2CbF0",
  supportEmail: "",
  dd: {
    apiKey: "DCEB26AC8BF47F1D7B4D87440EDCA6",
    jsPath: "https://node.deso.org/tags.js",
    ajaxListenerPath: "node.deso.org/api",
    endpoint: "https://node.deso.org/js/",
  },
  amplitude: {
    key: "ba127556985bcf271b9bb1eee6834918",
    domain: "amp.diamondapp.com",
  },
  heap: {
    appId: "1382101420",
  },
  hotjar: {
    hjid: "",
  },
  node: {
    id: 30,
    name: "My DeSo Space",
    url: "https://mydesospace.com",
    logoAssetDir: "/assets/diamond/",
  },
  appName: {
    id: 30,
    name: "My DeSo Space",
    url: "https://mydesospace.com",
    logoAssetDir: "/assets/diamond/",
  },
  megaswapURL: "https://heroswap.com",
  megaswapAPI: "https://heroswap.com",
  megaswapAffiliateAddress: "mydesospace",
  megaswapAffiliateName: "mydesospace",
  openfundURL: "https://openfund.com",
  setuAPI: "https://web3setu.co.in",
};
